export default "__VITE_ASSET__BIaSipkY__"